import { banco } from '../db/banco'
import { obterOuCriarPedidoAberto, adicionarItem } from './carrinho'
import { avulsasDoItem, SEM_AVULSAS } from './precos'
import type { Avulsas } from './precos'
import { resolverPreco } from './resolverPreco'

export async function repetirPedido(
  clienteId: string,
): Promise<{ pedidoId: string; adicionados: number; pulados: number }> {
  const novoPedido = await obterOuCriarPedidoAberto(clienteId)

  const anteriores = await banco.pedidos
    .where('cliente_id')
    .equals(clienteId)
    .filter((p) => p.apagado_em === null && p.status === 'fechado' && p.id !== novoPedido.id)
    .sortBy('criado_em')
  const ultimo = anteriores[anteriores.length - 1]
  if (!ultimo) return { pedidoId: novoPedido.id, adicionados: 0, pulados: 0 }

  const subPedidos = await banco.sub_pedidos
    .where('pedido_id')
    .equals(ultimo.id)
    .filter((s) => s.apagado_em === null && s.status !== 'cancelado')
    .toArray()

  let adicionados = 0
  let pulados = 0
  for (const subPedido of subPedidos) {
    // Sub-pedido sem tabela nao deve ocorrer no modelo novo; se ocorrer, pula.
    if (!subPedido.tabela_preco_id) {
      const n = await banco.itens_pedido
        .where('sub_pedido_id').equals(subPedido.id)
        .filter((i) => i.apagado_em === null).count()
      pulados += n
      continue
    }
    const itens = await banco.itens_pedido
      .where('sub_pedido_id')
      .equals(subPedido.id)
      .filter((i) => i.apagado_em === null)
      .toArray()
    for (const item of itens) {
      const produto = await banco.produtos.get(item.produto_id)
      if (!produto || produto.apagado_em !== null || !produto.ativo) {
        pulados++
        continue
      }
      // A parte SOLTA do item tem de vir junto: sem isto, repetir "2 caixas +
      // 6 unidades" devolvia "2 caixas" -- sem erro, sem aviso e com o total
      // menor. O preco vem da tabela de HOJE, como ja acontecia com o preco da
      // embalagem; o `preco_avulso` gravado no item velho e historia, nao
      // tabela de precos.
      const querAvulsas = avulsasDoItem(item).quantidade
      let avulsas = SEM_AVULSAS as Avulsas
      if (querAvulsas > 0) {
        const precoHoje = await resolverPreco(item.produto_id, clienteId, subPedido.tabela_preco_id)
        // A fabrica parou de vender a unidade solta desta linha. Nao ha preco
        // que nao seja chute, e adicionarItem recusaria de qualquer forma --
        // entao pula e CONTA, que e o que a tela ja sabe avisar.
        if (!precoHoje || precoHoje.precoUnidade === null) {
          pulados++
          continue
        }
        avulsas = { quantidade: querAvulsas, preco: precoHoje.precoUnidade }
      }
      const resultado = await adicionarItem(
        novoPedido.id, clienteId, produto, subPedido.tabela_preco_id, item.quantidade, avulsas,
      )
      if (resultado.sucesso) adicionados++
      else pulados++ // sem preco atual naquela tabela: melhor pular do que chutar
    }
  }
  return { pedidoId: novoPedido.id, adicionados, pulados }
}
